<template>
	<b-card no-body>
		<div slot="header" class="d-flex justify-content-between custom-card-header">
			<h5 class="card-header-title">{{ headerTitle }}</h5>

			<div class="card-header-actions">
				<div class="searchInCard">
					<b-input-group size="sm">
						<b-form-input @input="filterChanged"
									  :value="filter"
									  size="sm"
									  :placeholder="$t('contragent.search')"
						>
						</b-form-input>
						<b-input-group-append>
							<b-button
								@click="clearFilter"
							>{{ $t('contragent.clear') }}
							</b-button>
						</b-input-group-append>
					</b-input-group>
				</div>
				<b-link
					@click="showCreateModal"
					size="sm" variant="primary"
				>
					<i class="fa fa-plus-circle"
					   style="font-size: 1.4em; color: #53575B; margin-right: 3px;"
					></i>
				</b-link>
			</div>
		</div>
		<b-card-body>
			<slot name="table">
			</slot>
			<slot></slot>
		</b-card-body>
	</b-card>
</template>

<script>
	export default {
		name: "base-card-with-table",
		props: {
			headerTitle: {
				type: String,
				default: '#Default Card Header'
			},
			filter: {
				type: String,
				default: ''
			}
		},
		methods: {
			showCreateModal () {
				this.$emit('create');
			},
			filterChanged (newVal) {
				this.$emit('filterChanged', newVal);
			},
			clearFilter () {
				this.$emit('clearFilter');
			}
		}
	}
</script>

<style scoped>

</style>
